"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Option.scss");
var Option = function Option(_ref) {
  var children = _ref.children,
    className = _ref.className,
    data = _ref.data,
    isDisabled = _ref.isDisabled,
    isFocused = _ref.isFocused,
    isSelected = _ref.isSelected,
    innerRef = _ref.innerRef,
    innerProps = _ref.innerProps;
  var isSticky = data.isSticky,
    dataClassName = data.dataClassName,
    description = data.description;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: (0, _classnames["default"])('cds-SearchableSelect-Option', {
      'cds-SearchableSelect-Option--Disabled': isDisabled,
      'cds-SearchableSelect-Option--Focused': isFocused,
      'cds-SearchableSelect-Option--Selected': isSelected,
      'cds-SearchableSelect-Option--Sticky': isSticky
    }, className, dataClassName),
    ref: innerRef
  }, innerProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-SearchableSelect-OptionValue"
  }, children), description && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-SearchableSelect-OptionDescription"
  }, description));
};
exports.Option = Option;